type ConfigType = {
  HOSTNAME: string | undefined;
  STRICT_MODE: boolean;
  KEYCLOAK_ENABLED: boolean;
  NATIVE_ENABLED: boolean;
  DISABLE_SSL: boolean;
  VERSION: string | undefined;
  API_URL: string;
  FIREBASE_API_KEY: string;
  FIREBASE_AUTH_DOMAIN: string;
  FIREBASE_PROJECT_ID: string;
  FIREBASE_STORAGE_BUCKET: string;
  FIREBASE_MESSAGING_SENDER_ID: string;
  FIREBASE_APP_ID: string;
  FIREBASE_MEASUREMENT_ID: string;
  STRIPE_PUBLISHABLE_KEY: string;
};

const Config: ConfigType = {
  HOSTNAME: process.env.REACT_APP_HOSTNAME,
  STRICT_MODE: process.env.REACT_APP_REACT_STRICT === "true",
  KEYCLOAK_ENABLED: process.env.REACT_APP_KEYCLOAK_ENABLED === "true",
  NATIVE_ENABLED: process.env.REACT_APP_NATIVE_ENABLED === "true",
  DISABLE_SSL: process.env.REACT_APP_DISABLE_SSL === "true",
  VERSION: process.env.REACT_APP_VERSION,
  API_URL: process.env.REACT_APP_API_URL || "https://app.data-revival.com",
  FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY || "",
  FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
  FIREBASE_MESSAGING_SENDER_ID:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID || "",
  FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "",
  STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "",
};

export default Config;
